export const state = {
  type: null,
  data: null,
};

export const getters = {
  typeModal(state) {
    return state.type;
  },
  dataModal(state) {
    return state.data;
  },
};

export const mutations = {
  openModal(state, { type, data }) {
    state.type = type;
    state.data = data;
  },
  changeModal(state, type) {
    state.type = type;
  },
  error(state, message) {
    state.type = "alert-danger";
    state.message = message;
  },
  clear(state) {
    state.type = null;
    state.data = null;
  },
};

export const actions = {
  openModal({ commit }, { type, data }) {
    commit("openModal", { type, data });
  },
  changeModal({ commit }, type) {
    commit("changeModal", type);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  clear({ commit }) {
    commit("clear");
  },
};
